var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoMini = function SvgLogoMini(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#096C93"
    },
    d: "M356.8,342.73H127.62c-11.12,0-20.13-9.01-20.13-20.13V304c0-11.12,9.01-20.13,20.13-20.13H356.8 c11.12,0,20.13,9.01,20.13,20.13v18.6C376.93,333.72,367.92,342.73,356.8,342.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27E9FF"
    },
    d: "M356.8,166.15H191.26c-11.12,0-20.13-9.01-20.13-20.13v-18.6c0-11.12,9.01-20.13,20.13-20.13H356.8 c11.12,0,20.13,9.01,20.13,20.13v18.6C376.93,157.14,367.92,166.15,356.8,166.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20CCEA"
    },
    d: "M415.66,254.44h-121.5c-11.12,0-20.13-9.01-20.13-20.13v-18.6c0-11.12,9.01-20.13,20.13-20.13h121.5 c11.12,0,20.13,9.01,20.13,20.13v18.6C435.79,245.43,426.78,254.44,415.66,254.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#17A6CC"
    },
    d: "M209.86,254.44H132.4c-11.12,0-20.13-9.01-20.13-20.13v-18.6c0-11.12,9.01-20.13,20.13-20.13h77.46 c11.12,0,20.13,9.01,20.13,20.13l0,18.6C229.99,245.43,220.97,254.44,209.86,254.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#054D5E"
    },
    d: "M209.86,431.52H132.4c-11.12,0-20.13-9.01-20.13-20.13v-18.6c0-11.12,9.01-20.13,20.13-20.13h77.46 c11.12,0,20.13,9.01,20.13,20.13l0,18.6C229.99,422.5,220.97,431.52,209.86,431.52z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoMini, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-mini.96d1477b.svg";
export { ForwardRef as ReactComponent };